// removed by extract-text-webpack-plugin
module.exports = {"title":"_2iAz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/pagetitle/style.css
// module id = 347
// module chunks = 9